import TreasuryApi from "./treasuryApi";
import {
  ACCOUNT_TYPE_OPTIONS,
  getAccountTypeLabel,
} from "./treasuryOptions";
import TreasuryCrudPanel from "./TreasuryCrudPanel";

export default function TreasuryAccountsPanel() {
  return (
    <TreasuryCrudPanel
      title="Cuentas de tesorería"
      description="Administrá las cuentas activas disponibles para nuevos movimientos."
      entityLabel="Cuenta"
      pluralLabel="las cuentas"
      emptyMessage="No hay cuentas cargadas."
      typeLabel="Tipo de cuenta"
      typeField="account_type"
      typeOptions={ACCOUNT_TYPE_OPTIONS}
      list={TreasuryApi.listAccounts}
      create={TreasuryApi.createAccount}
      update={TreasuryApi.updateAccount}
      remove={TreasuryApi.deleteAccount}
      getTypeLabel={getAccountTypeLabel}
    />
  );
}
